import script from "./LanguageManagementModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LanguageManagementModal.vue?vue&type=script&setup=true&lang=js"

import "./LanguageManagementModal.vue?vue&type=style&index=0&id=16cabd98&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-16cabd98"]])

export default __exports__